export const whyIbankey = `
  <div class="mt-20" data-aos="fade-up"> 
       <div
      class=" w-full lg:w-[80%] mx-auto"
      data-aos="fade-up"
      data-aos-duration="300"
    >
       <h2 class="lg:text-4xl font-medium text-[#000072] text-xl text-center">
          Why ibankey?
        </h2> 
      <p class="text-center text-gray-600 py-7 ">
        We are a full-stack institutional debt raising platform 
        that offers solutions to all stakeholders
      </p>

      <div class="flex flex-col gap-3">
        <!-- 1st card -->
        <div
          class="flex flex-col lg:flex-row p-5 gap-7 lg:h-72 bg-[#f8fbff] shadow-lg border border-gray-300 rounded-lg"
          data-aos="fade-up"
          data-aos-duration="300"
        >
          <div id="oneplatform" class="mx-auto object-fill hidden lg:block">
           
          </div>
          <div class="w-full lg:w-1/2 p-4">
            <p class="text-xl font-semibold">
              One Platform, Endless Possibilities
            </p>
            <div class="flex gap-3 items-start mt-5"></div>
            <p class="text-gray-600 font-[500]">
              Our unified platform brings everyone together removing friction
              from the financial journey and ensuring smoother communication,
              faster approvals, and greater transparency at every step.
            </p>

            <div class="flex gap-3 items-start mt-2"></div>
            <p class="text-gray-600 font-[500]">
              With intelligent automation and real-time data sharing, tasks that
              once took days can now be completed in minutes. From document
              collection to disbursal, every process is optimized for speed and
              accuracy.
            </p>
          </div>
        </div>

        <!-- 2nd card -->
        <div
          class="flex flex-col lg:flex-row-reverse p-5 lg:h-72 gap-7 bg-[#f8fbff] shadow-lg border border-gray-300 rounded-lg"
          data-aos="fade-up"
          data-aos-duration="300"
        >
          <div id="aiLottie" class="mx-auto object-fill hidden lg:block">

          </div>
          <div class="w-full lg:w-1/2 p-4">
            <p class="text-xl font-semibold">AI-Driven Precision</p>
            <div class="flex gap-3 items-start mt-5"></div>
            <p class="text-gray-600 font-[500]">
              Our AI models analyze thousands of data points instantly to
              evaluate risk, reducing human error and enhancing decision
              accuracy—resulting in quicker loan approvals with confidence.
            </p>

            <div class="flex gap-3 items-start mt-2"></div>
            <p class="text-gray-600 font-[500]">
              With every interaction, our AI gets smarter adapting to new
              trends, user behavior, and market changes to refine underwriting
              models and deliver more precise outcomes
            </p>
          </div>
        </div>

        <!-- 3rd card -->
        <div
          class="flex flex-col lg:flex-row p-5 gap-7 bg-[#f8fbff] lg:h-72 shadow-lg border border-gray-300 rounded-lg"
          data-aos="fade-up"
          data-aos-duration="300"
        >
          <div id="funLottie" class="mx-auto   h-52 object-fill hidden lg:block">
           
          </div>
          <div class="w-full lg:w-1/2 p-4">
            <p class="text-xl font-semibold">Faster Fundraising</p>
            <div class="flex gap-3 items-start mt-5"></div>
            <p class="text-gray-600 font-[500]">
              Our platform reduces the time taken to secure funding by 80%. By
              digitizing the entire fundraising process, we eliminate manual
              bottlenecks allowing businesses to access capital when they need
              it most.
            </p>

            <div class="flex gap-3 items-start mt-2"></div>
            <p class="text-gray-600 font-[500]">
              Our intelligent matchmaking connects you with the right funding
              partners in seconds, streamlining introductions and reducing
              negotiation cycles.
            </p>
          </div>
        </div>

        <!-- 4th card -->
        <div
          class="flex flex-col lg:flex-row-reverse p-5 gap-7 lg:h-72 bg-[#f8fbff] shadow-lg border border-gray-300 rounded-lg"
          data-aos="fade-up"
          data-aos-duration="300"
        >
          <div id="mangementLottie" class="mx-auto object-fill hidden lg:block">
           
          </div>
          <div class="w-full lg:w-1/2 p-4">
            <p class="text-xl font-semibold">End-to-End Deal Management</p>
            <div class="flex gap-3 items-start mt-5"></div>
            <p class="text-gray-600 font-[500]">
              Our platform simplifies complex deal flows with intuitive
              workflows, automated documentation, and centralized communication
              ensuring nothing falls through the cracks.
            </p>

            <div class="flex gap-3 items-start mt-2"></div>
            <p class="text-gray-600 font-[500]">
              All parties borrowers, lenders, legal teams, and partners—can work
              together in one shared space, eliminating back-and-forth and
              reducing turnaround times.
            </p>
          </div>
        </div>
      </div>
    </div>

      <!-- section 2 -->
      <div class="mt-24" data-aos="fade-up" data-aos-duration="300">
     <h2 class="lg:text-4xl font-medium text-[#000072] text-xl text-center">
         Our AI Features
        </h2>
    <p class="py-2 text-center text-gray-500 mb-6 px-0 lg:px-24">
      Intelligent Al driven features that add tangible value to our customers
      - Businesses & lenders <br />
      A transformative user Experience for all Stakeholders involved.
    </p>
    <div 
      class="p-6 flex flex-col lg:flex-row items-center gap-14 text-center w-full lg:w-[80%] mx-auto rounded-lg shadow-lg border border-gray-300 rounded-lg/20"
      data-aos="fade-up" data-aos-duration="300">
      <img
        src="https://cdn.prod.website-files.com/66fa316cedfc575e36fbffca/67013da7aeea15a9f6e8a81e_inner-pattern-1.png"
        class="transition-all duration-1000 ease-in-out hidden lg:block" 
        alt="Ibankey"
        />

   
      <div id="airobotLottie" class="h-64 mb-4"></div>
      <div class="flex flex-col gap-4 z-10">
        <div class="flex gap-2">
          <p class="text-lg font-semibold text-gray-600">
            <i class="fa-solid fa-envelope text-lg"></i>
          </p>
          <p class="text-sm mt-1 text-gray-500">
            Intelligent Context Generation.
          </p>
        </div>
        <div class="flex gap-2">
          <p class="text-lg font-semibold text-gray-600">
            <i class="fa-solid fa-map-location-dot text-lg"></i>
          </p>
          <p class="text-sm mt-1 text-gray-500">
            Underwriting Management Solutions.
          </p>
        </div>
        <div class="flex gap-2">
          <p class="text-lg font-semibold text-gray-600">
            <i class="fa-solid fa-sitemap text-lg"></i>
          </p>
          <p class="text-sm mt-1 text-gray-500">Lender Matching Engine</p>
        </div>
        <div class="flex gap-2">
          <p class="text-lg font-semibold text-gray-600">
            <i class="fa-solid fa-lock text-lg"></i>
          </p>
          <p class="text-sm mt-1 text-gray-500">
            Smart Deal Collaterals & Materials.
          </p>
        </div>
        <div class="flex gap-2">
          <p class="text-lg font-semibold text-gray-600">
            <i class="fa-brands fa-markdown text-lg"></i>
          </p>
          <p class="text-sm mt-1 text-gray-500">Product Advisor System.</p>
        </div>
        <div class="text-start">
          <a href="#"
            class="group inline-flex items-center text-gray-500 hover:text-blue-600 border border-transparent hover:border-blue-600 px-4 py-2 rounded-full transition-all duration-300">
            Learn More
            <i
              class="fa-solid fa-arrow-right text-lg ml-2 transform group-hover:translate-x-1 transition-transform duration-300"></i>
          </a>

          </a>
        </div>
      </div>
    </div>
  </div>
    </div>
`;
